import Client from './client';

export default class MerchantOfRecordEntitySettings extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/merchant-of-record-entity`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/merchant-of-record-entity`, {
      ...options,
       method: 'POST',
    });
  }

  getById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/merchant-of-record-entity/${id}`, options);
  }

  putById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/merchant-of-record-entity/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/merchant-of-record-entity/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
